'use strict';

exports.__esModule = true;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _genericRowItem = require('../generic-row-item');

var _genericRowItem2 = _interopRequireDefault(_genericRowItem);

var _submitButton = require('./submit-button.scss');

var _submitButton2 = _interopRequireDefault(_submitButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
    onSearch: _propTypes2.default.func.isRequired,
    searchQuery: _propTypes2.default.string.isRequired
};

var SubmitButton = function SubmitButton(props) {
    return _react2.default.createElement(
        _genericRowItem2.default,
        null,
        _react2.default.createElement(
            'button',
            {
                className: _submitButton2.default.submitButton,
                onClick: function onClick() {
                    props.onSearch(props.searchQuery);
                },
                'data-auto-action': 'search:button'
            },
            _react2.default.createElement('i', {
                className: _submitButton2.default.icon
            })
        )
    );
};

SubmitButton.propTypes = propTypes;
exports.default = SubmitButton;